<mat-dialog-content class="mat-typography TC_container">
  <div class="section_login">
    <div class="body-gap">
      <div class="add-card-details">
        Add new Card Details
      </div>

      <button style="outline: none;" class="close-button forgetPass" (click)="CloseModal()" [mat-dialog-close]="true"
        id="closeBtn">
        <img src="../../../assets/icons/x-button.svg">
      </button>


      <mat-card>
        <mat-card-content>
          <div [formGroup]="stripeTest" fxLayout="column">
            <mat-form-field>
              <mat-label *ngIf="!stripeTest.value.name">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Name</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <ngx-stripe-card [options]="cardOptions"></ngx-stripe-card>
          </div>
        </mat-card-content>
        <mat-card-actions fxLayout="row">
          <mat-divider></mat-divider>
          <span fxFlex></span>
        </mat-card-actions>
      </mat-card>

      <!-- <form id="payment-form"> -->
      <!-- <div>
          <label for="card-holder-name">Cardholder Name</label>
          <input type="text" id="card-holder-name" required>
        </div>
        <div>
          <label for="card-number">Card Number</label>
          <div id="card-number"></div>
        </div>
        <div>
          <label for="expiry">Expiration Date</label>
          <div id="expiry"></div>
        </div>
        <div>
          <label for="cvc">CVC</label>
          <div id="cvc"></div>
        </div> -->
      <!-- <button id="submit-button">Submit</button> -->
      <!-- <div>
        <div id="card-element"></div>
        <button (click)="onSubmit()">Pay</button>
      </div> -->
      <!-- <form [formGroup]="cardform">
        <div>
          <mat-form-field appearance="fill" class="Cardholder-name">
            <input matInput type="text" placeholder="Cardholder's name" formControlName="name">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field appearance="fill" class="Cardholder-name">
            <input (keypress)="numberOnly($event)" matInput type="tel" placeholder="Card number"
              formControlName="number" maxlength="16">
          </mat-form-field>
        </div>

        <div class="last-line">
          <mat-form-field appearance="fill" class="expiry-date">
            <input matInput type="tel" placeholder="Expiry Month" formControlName="date">
          </mat-form-field>
          
          <mat-form-field appearance="fill" class="expiry-date">
            <input (keypress)="numberOnly($event)" matInput type="tel" placeholder="Expiry Year" formControlName="year">
          </mat-form-field>

          <mat-form-field appearance="fill" class="expiry-date">
            <input (keypress)="numberOnly($event)" matInput type="tel" placeholder="CVV" formControlName="cvvno" maxlength="3">
          </mat-form-field>
        </div>
      </form> -->

      <div>
        <!-- <button mat-raised-button color="warn" [mat-dialog-close]="true" class="Add-card-button" [disabled]="cardform.value.name == '' || cardform.value.number == '' || cardform.value.date == '' ||
        cardform.value.cvvno == '' " (click)="savecard()">
          Add Card
        </button> -->
        <button mat-raised-button [disabled]="stripeTest.status!='VALID'" color="warn" id="submit-button" type="submit"
          [mat-dialog-close]="true" class="Add-card-button" (click)="savecard()">
          Add Card
        </button>
      </div>
      <!-- </form> -->

    </div>
  </div>